/* eslint-disable prettier/prettier */
import toast from "react-hot-toast";
import {
  GetAllHospitales,
  GetAllParentesco,
  GetAllServiciosMedicos,
  GetAllEstudios,
  GetAllCorreos,
  GetMedicos,
  InsertHospital,
  InsertParentesco,
  InsertEstudio,
  InsertServiciosMedicos,
  InsertCorreo,
  UpdateServiciosMedicos,
  UpdateParentesco,
  UpdateHospital,
  UpdateEstudio,
  UpdateCorreo,
} from "../apis";

import {
  setData,
  setUserAdd,
  isLoading,
  setUserError,
  closeAlert,
  updateCheckCat,
  updateEdit,
  updateEditText,
  insertCatalogo,
  UpdateItem,
} from "./catalogosSlice";

import axios from "axios";

import { map } from "lodash";

import { store } from "../store";

export function HandleEditSave(dispatch, { catalogo, item }) {
  if (catalogo === "hospitales") {
    UpdateHospitalT(dispatch, item);
  }
  if (catalogo === "servicios") {
    UpdateServiciosT(dispatch, item);
  }
  if (catalogo === "parentescos") {
    UpdateParentescosT(dispatch, item);
  }
  if (catalogo === "estudios") {
    UpdateEstudiosT(dispatch, item);
  }
  if (catalogo === "correos") {
    UpdateCorreosT(dispatch, item);
  }
}
function UpdateParentescosT(dispatch, item) {
  const token = store.getState().login.token;
  let id = toast.loading("Actualizando Parentescos...");
  let data = {
    idParentescoCandidato: item.idParentescoCandidato,
    descripcion: item.descripcion,
    activo: item.activo,
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(UpdateParentesco(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(UpdateItem({ type: "CAT_PARENTESCOS", data: item }));
        toast.success("Actualiacion exitoso!");
      } else {
        toast.error("Ocurrio un error : Parentescos :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Parentescos :");
    });
}
function UpdateServiciosT(dispatch, item) {
  const token = store.getState().login.token;
  let id = toast.loading("Actualizando Servicio Medico...");
  let data = {
    idServicioMedico: item.idServicioMedico,
    descripcion: item.descripcion,
    orden: 0,
    activo: item.activo,
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(UpdateServiciosMedicos(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(UpdateItem({ type: "CAT_SER_MEDICOS", data: item }));
        toast.success("Actualizacion exitoso!");
      } else {
        toast.error("Ocurrio un error : Servicios Medicos :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Servicios Medicos :");
    });
}
function UpdateHospitalT(dispatch, item) {
  const token = store.getState().login.token;
  let id = toast.loading("Actualizando hospital...");
  let data = {
    idHospital: item.idHospital,
    hospital: item.hospital,
    usuarioId: 147,
    activo: item.activo,
  };
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(UpdateHospital(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(UpdateItem({ type: "CAT_HOSPITAL", data: item }));
        toast.success("Actualizacion exitoso!");
      } else {
        toast.error("Ocurrio un error : Hospitales :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Hospitales :");
    });
}
function UpdateEstudiosT(dispatch, item) {
  const token = store.getState().login.token;
  let id = toast.loading("Actualizando Estudio Médico...");
  let data = {
    idEstudio: item.idEstudio,
    descripcion: item.descripcion,
    precio: 0,
    aureaLab: 0,
    activo: item.activo,
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(UpdateEstudio(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(UpdateItem({ type: "CAT_ESTUDIOS", data: item }));
        toast.success("Actualizacion exitoso!");
      } else {
        toast.error("Ocurrio un error : Estudios Médicos :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Estudios Médicos :");
    });
}
function UpdateCorreosT(dispatch, item) {
  const token = store.getState().login.token;
  let id = toast.loading("Actualizando Correo de destinario...");
  let data = {
    id: item.id,
    correo: item.correo,
    activo: item.activo,
    nombre: "",
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(UpdateCorreo(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(UpdateItem({ type: "CAT_CORREOS", data: item }));
        toast.success("Actualizacion exitoso!");
      } else {
        toast.error("Ocurrio un error : Correo de destinatario :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Correo de destinatario :");
    });
}

export function HandleSaveCat(dispatch, { catalogo, value }) {
  if (catalogo === "hospitales") {
    SaveHospital(dispatch, value);
  }
  if (catalogo === "servicios") {
    SaveServicios(dispatch, value);
  }
  if (catalogo === "parentescos") {
    SaveParentescos(dispatch, value);
  }
  if (catalogo === "estudios") {
    SaveEstudio(dispatch, value);
  }
  if (catalogo === "correos") {
    SaveCorreo(dispatch, value);
  }
}
function SaveParentescos(dispatch, value) {
  const token = store.getState().login.token;
  let id = toast.loading("Registrando Parentescos...");
  let data = {
    idParentescoCandidato: 0,
    descripcion: value,
    activo: true,
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(InsertParentesco(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(insertCatalogo({ type: "CAT_PARENTESCOS", data: response.data.data }));
        toast.success("Registro exitoso!");
      } else {
        toast.error("Ocurrio un error : Parentescos :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Parentescos :");
    });
}
function SaveServicios(dispatch, value) {
  const token = store.getState().login.token;
  let id = toast.loading("Registrando Servicio Medico...");
  let data = {
    idServicioMedico: 0,
    descripcion: value,
    orden: 0,
    activo: true,
    usuarioId: 147,
  };

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(InsertServiciosMedicos(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(insertCatalogo({ type: "CAT_SER_MEDICOS", data: response.data.data }));
        toast.success("Registro exitoso!");
      } else {
        toast.error("Ocurrio un error : Servicios Medicos :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Servicios Medicos :");
    });
}
function SaveHospital(dispatch, value) {
  const token = store.getState().login.token;
  let id = toast.loading("Registrando hospital...");
  let data = {
    hospital: value,
    usuarioId: 147,
  };
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(InsertHospital(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(insertCatalogo({ type: "CAT_HOSPITAL", data: response.data.data }));
        toast.success("Registro exitoso!");
      } else {
        toast.error("Ocurrio un error : Hospitales :" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Hospitales :");
    });
}
function SaveEstudio(dispatch, value) {
  const token = store.getState().login.token;
  let id = toast.loading("Registrando estudio...");
  let data = {
    descripcion: value,
    precio: 0,
    aureaLab: 0,
    usuarioId: 147,
  };
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(InsertEstudio(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(insertCatalogo({ type: "CAT_ESTUDIOS", data: response.data.data }));
        toast.success("Registro exitoso!");
      } else {
        toast.error("Ocurrio un error : Estudios Médicos:" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Estudios Médicos :");
    });
}
function SaveCorreo(dispatch, value) {
  const token = store.getState().login.token;
  let id = toast.loading("Registrando correo...");
  let data = {
    correo: value,
    nombre: "",
    usuarioId: 147,
  };
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(InsertCorreo(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(insertCatalogo({ type: "CAT_CORREOS", data: response.data.data }));
        toast.success("Registro exitoso!");
      } else {
        toast.error("Ocurrio un error : Correo de destinatario:" + response.data.mensaje);
      }
    })
    .catch((error) => {
       
      toast.remove(id);
      toast.error("Ocurrio un error : Correo de destinatario :");
    });
}

export function HandleEditText(dispatch, { catalogo, item, value }) {
  if (catalogo === "hospitales")
    dispatch(updateEditText({ type: "CAT_HOSPITAL", data: item, nuevoValor: value }));
  if (catalogo === "servicios")
    dispatch(updateEditText({ type: "CAT_SER_MEDICOS", data: item, nuevoValor: value }));
  if (catalogo === "parentescos")
    dispatch(updateEditText({ type: "CAT_PARENTESCOS", data: item, nuevoValor: value }));
  if (catalogo === "estudios")
    dispatch(updateEditText({ type: "CAT_ESTUDIOS", data: item, nuevoValor: value }));
  if (catalogo === "correos")
    dispatch(updateEditText({ type: "CAT_CORREOS", data: item, nuevoValor: value }));
}
export function HandleEdit(dispatch, { catalogo, item }) {
  if (catalogo === "hospitales") dispatch(updateEdit({ type: "CAT_HOSPITAL", data: item }));
  if (catalogo === "servicios") dispatch(updateEdit({ type: "CAT_SER_MEDICOS", data: item }));
  if (catalogo === "parentescos") dispatch(updateEdit({ type: "CAT_PARENTESCOS", data: item }));
  if (catalogo === "estudios") dispatch(updateEdit({ type: "CAT_ESTUDIOS", data: item }));
  if (catalogo === "correos") dispatch(updateEdit({ type: "CAT_CORREOS", data: item }));
}

export function HandleCheck(dispatch, { catalogo, item }) {

  if (catalogo === "hospitales") dispatch(updateCheckCat({ type: "CAT_HOSPITAL", data: item }));
  if (catalogo === "servicios") dispatch(updateCheckCat({ type: "CAT_SER_MEDICOS", data: item }));
  if (catalogo === "parentescos") dispatch(updateCheckCat({ type: "CAT_PARENTESCOS", data: item }));
  if (catalogo === "estudios") dispatch(updateCheckCat({ type: "CAT_ESTUDIOS", data: item }));
  if (catalogo === "correos") dispatch(updateCheckCat({ type: "CAT_CORREOS", data: item }));
}

export function InformacionInicialCatalogos(dispatch) {
  getHospitales(dispatch);
  getParentescos(dispatch);
  getSerMedicos(dispatch);
  getEstudiosMedicos(dispatch);
  getCorreosDestinatarios(dispatch);
}
export function getHospitales(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_HOSPITAL", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetAllHospitales(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_HOSPITAL", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_HOSPITAL", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_HOSPITAL", data: false }));
    });
}

export function getParentescos(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_PARENTESCOS", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetAllParentesco(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_PARENTESCOS", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_PARENTESCOS", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_PARENTESCOS", data: false }));
    });
}
export function getSerMedicos(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_SER_MEDICOS", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetAllServiciosMedicos(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_SER_MEDICOS", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_SER_MEDICOS", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_SER_MEDICOS", data: false }));
    });
}
export function getEstudiosMedicos(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_ESTUDIOS", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetAllEstudios(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_ESTUDIOS", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_ESTUDIOS", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_ESTUDIOS", data: false }));
    });
}
export function getCorreosDestinatarios(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_CORREOS", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetAllCorreos(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_CORREOS", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_CORREOS", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_CORREOS", data: false }));
    });
}

export function getMedicos(dispatch, idHospital) {
  const token = store.getState().login.token;
  dispatch(isLoading({ type: "CAT_MEDICOS", data: true }));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(GetMedicos().concat("/").concat(idHospital), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setData({ type: "CAT_MEDICOS", data: response.data.data }));
      }
      dispatch(isLoading({ type: "CAT_MEDICOS", data: false }));
    })
    .catch((error) => {
       
      dispatch(isLoading({ type: "CAT_MEDICOS", data: false }));
    });
}
